<template>
  <header>
    <div class="content-container-column header-content-container">
      <a
        class="ep-home"
        :href="rtsData.url"
        target="_blank"
      >
        <img v-if="getT" src="../../assets/images/logo-white.svg" v-bind:alt="getT.static.back_to_main_site"/>
      </a>
      <h1 v-if="getT">{{getT.static.pool_select[0].top_heading}}</h1>
      <p v-if="getT">{{getT.static.pool_select[0].top_paragraph}}</p>
    </div>
  </header>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ModelSelectHeader',
  computed: {
    ...mapGetters(['rtsData', 'getT']),
  },
};
</script>
<style lang="scss" scoped>
header {
  width: 100%;
  padding-bottom: 1.5em;
  background-color: $deep-navy;
  .header-content-container {
    padding-top: 1.5rem;
    .ep-home, h1, p {
      user-select: none;
    }
    .ep-home {
      cursor: pointer;
    }
    h1 {
      font-family: 'Austin Bold';
      letter-spacing: 1px;
      margin: 0.5em 0;
      font-size: 2.25rem;
    }
    p {
      font-family: 'Europa Regular';
      font-size:1.125rem;
      line-height: 1.6875rem;
    }
  }
}
</style>
  